module.exports = __webpack_public_path__ + "188c057ebd0422b6f6a3042b0ef27ac3.fbx";